<form class="flex-col flex" #schemeSearchForm="ngForm">
    <mat-card class="cb-margin end flex">
        <mat-card-content>
            <div class="start-center flex-row flex" *cbWaitFor="lotMappedItem">
                <mat-icon class="cb-grey">search</mat-icon>
                <mat-form-field class="cb-margin-left cb-margin-right flex">
                    <mat-label>Search Schemes</mat-label>
                    <input
                        matInput
                        type="text"
                        name="search"
                        [(ngModel)]="userCacheItem.data.query"
                    />
                </mat-form-field>
                <span class="flex"></span>
                <div class="flex-row">
                        @if (lotDesignPermissions.canRequestScheme()) {
                            <cb-button
                                [disabled]="!lotMappedItem.canRequestDesignScheme"
                                (clicked)="requestDesignSchemeSteps()"
                                (popupClick)="applySpecTemplate()"
                                color="primary"
                                [isStroked]="false"
                                [popup]="{
                        description: 'Specification Template not applied.',
                        buttonText: 'Apply Spec Template',
                        disabled: lotMappedItem.lotSpecLocked
                    }"
                            >
                                Request Design Scheme
                            </cb-button>
                        }

                    @if (lotDesignPermissions.canCreateScheme()) {
                        <button
                            mat-raised-button
                            color="primary"
                            [ngClass]="
                                !lotMappedItem.canRequestDesignScheme &&
                                !lotMappedItem.hasSpecTemplate
                                    ? 'cb-margin-left-4x'
                                    : 'cb-margin-left-2x'
                            "
                            (cbClick)="createDesignScheme()"
                        >
                            Create Design Scheme
                        </button>
                    }
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <div
        class="scroll-container"
        [cbInfiniteScroll]="listContainer"
        [fetch]="fetchResults()"
        [queryUpdated]="queryUpdate"
        [enabled]="searchEnabled"
        [(results)]="results"
        [(currentPage)]="currentPage"
    >
        @if (shouldShowNoResultsMessage()) {
            <cb-info-message
                message="There are no Design Schemes available for your search criteria"
                iconClass="cb-accent"
            >
            </cb-info-message>
        }
        <div class="flex-wrap" #listContainer>
            <ng-container *cbWaitFor="resultsLoaded$$ | async">
                @for (result of results; track result) {
                    <cb-design-scheme-card
                        class="flex-col md-33 lg-33 sm-50 xl-25 xs-100 flex-25"
                        [mappedItem]="result"
                        [lot]="lotMappedItem"
                        (viewClick)="viewDesignScheme($event)"
                    >
                    </cb-design-scheme-card>
                }
            </ng-container>
        </div>
    </div>
</form>
